import { C as Cart } from './cart-Br6PnlY6.js';
import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';

class CartItems extends HTMLElement {
  unsubscribers = [];

  static {
    Cart.sections.push('fetch-line-items');
    Cart.sections.push('fetch-line-items-cart-drawer');
  }

  connectedCallback() {
    ['cart:add', 'cart:change'].forEach((event) =>
      this.unsubscribers.push(
        Pubsub.subscribe(event, ({ sections }) => this.renderSections(sections))
      )
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Render the sections.
   * @param {Object} sections - The sections to render.
   */
  renderSections(sections) {
    const isInDrawer = this.closest('#cart-drawer') !== null;
    const sectionName = isInDrawer ? 'fetch-line-items-cart-drawer' : 'fetch-line-items';

    const html = new DOMParser().parseFromString(sections[sectionName], 'text/html');
    const target = html.querySelector('line-items');
    this.innerHTML = target.innerHTML;
  }
}

customElements.define('line-items', CartItems);
